import React from "react";
import Breadcrumb from "@airasia/phoenix-widgets/widgets/Breadcrumb";


export default function breadcrumb(props) {
  const cardData = props.data;
    const renderCard = (card) => {
        return (
            <Breadcrumb
  accessible
  activeColor="primary"
  hoverUnderlined
  activeStep={2}
  crumbs={[
    {
      path: 'https://www.airasia.com/aa/restaurant-lists/',
      step: 0,
      title: 'Merchant'
    },
    {
      path: card.url,
      step: 1,
      title: card.title
    },
  ]}
  customProperties={{
    'aria-label': 'this is an a11y custom label',
    id: 'customPropsID'
  }}
  disabledColor="greyDark"
  activeColor="greyDarker"
  fontSize="normal"
  hasBorderBottom={false}
  hoverColor=""
  hoverUnderlined={false}
  isClickable={false}
  target="self"
  isClickable
  theme="AIRASIA_CLASSIC"
/>
        );
    }
    return (
      cardData.map(renderCard)
  );
}
